export default function saveFile(file, { type, name }) {
	let blob = new Blob([file], { type })
	if (window.navigator.msSaveOrOpenBlob) {
		navigator.msSaveBlob(blob, name)
	} else {
		const link = document.createElement('a')
		const url = window.URL || window.webkitURL || window.moxURL
		link.href = url.createObjectURL(blob)
    link.download = name
    link.style.display = 'none'
    document.body.appendChild(link)
		link.click()
    url.revokeObjectURL(link.href)
    document.body.removeChild(link)
	}
}
